/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import { instalacionSelector, resultadoAutenticacionSelector, usuarioSelector } from '../../selectors/sessionSelector'

import { headerSelector } from '../../selectors/layoutSelector' 
import * as Notification from '../../components/Common/notification'
import Login from '../../components/Login'

const LoginContainer = ({
    match, 
    initializeForm, 
    resultadoAutenticacion,
    setResultadoAutenticacion, 
    setPermiteUsuarioAnonimo, 
    setHeaderShow, 
    sagaAutenticarUsuario, 
    sagaRestablecerContrasenia,
    sagaOlvidoContrasenia,
    sagaValidarCodigo,
    usuario,
    instalacion,
    ...props
    }) => {
    const [loginData, setLoginData] = React.useState({
        email: '',
        contrasenia: '',
        nuevaContrasenia: undefined,
        repeticionNuevaContrasenia: undefined,
        emailOlvidoContrasenia: undefined,
        userId: undefined,
    });
    const [errores, setErrores] = React.useState({});
    const [olvidoContrasenia, setOlvidoContrasenia] = React.useState(false);

    React.useEffect(() => {
        const { params } = match;
        setOlvidoContrasenia(params.idUsuario != null ? true : false);
        initializeForm();

        setPermiteUsuarioAnonimo(true)

        return () => {
            setPermiteUsuarioAnonimo(false);
            showHeaderAndFooter(true);
            setResultadoAutenticacion({ error:undefined, restablecerContrasenia: false })
        }
    }, [])


    const showHeaderAndFooter = (mostrar) => {
        setHeaderShow(mostrar)
        //this.props.setFooterShow(mostrar)
    }

    const handleOnDataChange = (event) => {
        event.persist();
        setLoginData(logData => ({...logData, [event.target.name]: event.target.value }))
    }

    const handleOnContraseniaKeyPress = (event) => {
        event.persist();
        if(event.key === 'Enter'){
            handleOnAutenticar()
        }
    }

    const handleOnAutenticar = () => {

        if(!validateLoginForm()) 
        {
            // limpio el mensaje de error de autenticación
            setResultadoAutenticacion({ error:undefined })
            return
        }

        // autentico el usuario
        sagaAutenticarUsuario({
            email: loginData.email,
            contrasenia: loginData.contrasenia,
            // idInstalacion: this.props.instalacion.id,
            onUsuarioAutenticado: handleOnUsuarioAutenticado
        })
    }

    React.useEffect(() => {
        if(usuario){
            handleOnUsuarioAutenticado();
            showHeaderAndFooter(true);
        } else {
            showHeaderAndFooter(false)
        }
    }, [usuario])

   const handleOnUsuarioAutenticado = () => {
    if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
        window.location.hash = '/'
        return
    }
        
    if(usuario && usuario.idRol === 2){
        window.location.hash = '/'
        return
    }
    }

    const validateLoginForm = () => {
        let valida = true
        let errores = {}

        
        // valido el email
        if(!loginData.email) {
            errores.email = 'Ingrese el email'
            valida = false
        }

        // valido la contraseña
        if(!loginData.contrasenia)
        {
            errores.contrasenia = 'Ingrese la contraseña'
            valida = false
        }

        // actualizo el estado con los errores
        setErrores(errores);

        return valida
    }

    const handleOnRestablecerContrasenia = () => {
        if(!validateRestablecerContraseniaForm())
            return
            let idUsuarioToken = 0

        sagaRestablecerContrasenia({
            idUsuario: match?.params?.idUsuario || props.resultadoAutenticacion?.usuarioId || loginData?.usuarioId || undefined,
            token: match?.params?.token || props.resultadoAutenticacion?.token || undefined,
            contrasenia: loginData.nuevaContrasenia,
            idUsuarioToken: idUsuarioToken,
            onContraseniaRestablecida: handleOnContraseniaRestablecida
          })
    }

    const handleOnContraseniaRestablecida = () => {
        Notification.showSuccess('La contraseña se restableció correctamente')
        window.location.hash = '/Login'
    }

    const handleOnCancelarRestablecerContrasenia = () => {
        setResultadoAutenticacion({ restablecerContrasenia: false, error: undefined })
        window.location.hash = '/Login'
    }

    const validateRestablecerContraseniaForm = () => {
        let valida = true
        let errores = {}

        // valido la nueva contraseña provisoria
        if(!loginData.nuevaContrasenia) 
        {
            errores.nuevaContrasenia = 'Ingrese la nueva contraseña provisoria'
            valida = false
        }

        // valido la repetición de la nueva contraseña provisoria
        if(!loginData.repeticionNuevaContrasenia)
        {
            errores.repeticionNuevaContrasenia = 'Vuelva a ingresar la contraseña provisoria'
            valida = false
        }
        else if(loginData.nuevaContrasenia !== loginData.repeticionNuevaContrasenia) 
        {
            errores.repeticionNuevaContrasenia = 'Las contraseñas no coinciden'
            valida = false
        }

        // actualizo el estado con los errores
        setErrores(errores);

        return valida
    }

    const handleOnOlvidoContraseniaClick = () => {
        
        // limpio el mensaje de error de autenticación
        setResultadoAutenticacion({ error:undefined, claveProvisoriaGenerada: false })

        // genero los cambios de estado
        setOlvidoContrasenia(true);
        setLoginData(logData => ({...logData, emailOlvidoContrasenia: logData.email}))
        
        if(errores !== undefined){
            setErrores(err => ({...err, emailOlvidoContrasenia: undefined}))
        } 

    }

    const handleOnOlvidoContrasenia = () => {
        
        // valido que se haya ingresado el email
        if(!loginData.emailOlvidoContrasenia)
        {
            setErrores({ emailOlvidoContrasenia: 'Ingrese el email' })
            return
        }

        // llamo a la lógica de olvido de contrasenia
        sagaOlvidoContrasenia({ email: loginData.emailOlvidoContrasenia })
    }

    const handleOnCancelarOlvidoContrasenia = () => {

        // limpio el mensaje de error de autenticación
        setResultadoAutenticacion({ error:undefined })

        setOlvidoContrasenia(false);
    }

    const getFormToShow = () => {
        let formToShow = 'login'

        if(resultadoAutenticacion.restablecerContrasenia)
            formToShow = 'restablecerContrasenia'

        if(olvidoContrasenia)
            formToShow = 'olvidoContrasenia'

        return formToShow
    }


    
    const handleOnConfirmarCodigo = () => {

        if (!loginData.codigoVerificacion) {
            setErrores({ codigoVerificacion: 'Ingrese el código' })
            return
        }

        let payload = {
            codigo: loginData.codigoVerificacion,
            email: loginData.emailOlvidoContrasenia,
            usuarioId: match?.params?.idUsuario || undefined
        }

        payload.callback = (response) => {
            setOlvidoContrasenia(false);
            setResultadoAutenticacion({error: undefined, restablecerContrasenia: true, usuarioId: response.usuarioId })
            setLoginData(logData => ({...logData, usuarioId: response.usuarioId}))
        }

        payload.callbackError = (msg) => {
            setErrores({ codigoVerificacion: msg })
        }

        setErrores({ codigoVerificacion: undefined })

        sagaValidarCodigo(payload)
    }

    const limpiarDatos = () => {
        setResultadoAutenticacion({token: undefined, usuarioId: true })
    }
        
    let formToShow = getFormToShow()
        
        return (
            <Login 
                instalacion={instalacion}
                formToShow={formToShow}
                errores={errores}
                loginData={loginData}
                handleOnDataChange={handleOnDataChange}
                handleOnContraseniaKeyPress={handleOnContraseniaKeyPress}
                handleOnAutenticar={handleOnAutenticar}
                handleOnRestablecerContrasenia={handleOnRestablecerContrasenia}
                handleOnCancelarRestablecerContrasenia={handleOnCancelarRestablecerContrasenia}
                handleOnOlvidoContraseniaClick={handleOnOlvidoContraseniaClick}
                handleOnOlvidoContrasenia={handleOnOlvidoContrasenia}
                handleOnConfirmarCodigo={handleOnConfirmarCodigo}
                handleOnCancelarOlvidoContrasenia={handleOnCancelarOlvidoContrasenia}
                resultadoAutenticacion={resultadoAutenticacion}
                limpiarDatos={limpiarDatos}
            />
        )
    }

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...sessionActions,
        ...layoutActions
	}, dispatch)
}

function mapStateToProps(state) {
    return {
      instalacion: instalacionSelector(state),
      usuario: usuarioSelector(state),
      resultadoAutenticacion: resultadoAutenticacionSelector(state),
      header: headerSelector(state),
      
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)